import { backgroundOrange, darkOrange, gold, orange } from '@/theme/colors'
import styled from 'styled-components'

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem;
    background: ${backgroundOrange};
    border-radius: 12px;
    margin-bottom: 1rem;
`

export const ExpenseName = styled.div`
    font-size: 1.125rem;
    font-weight: 600;
    color: #262626;
    text-align: center;
`

export const PaidByRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.25rem;
`

export const PaidByLabel = styled.span`
    font-size: 0.75rem;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
`

export const PaidByName = styled.span`
    font-size: 0.875rem;
    font-weight: 500;
    color: #262626;
`

export const Avatar = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${orange};
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
    flex-shrink: 0;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`

export const AmountRow = styled.div`
    text-align: center;
    margin-bottom: 0.5rem;
`

export const Amount = styled.span`
    font-size: 2rem;
    font-weight: 700;
    color: ${darkOrange};
`

export const CurrencyCode = styled.span`
    font-size: 0.875rem;
    font-weight: 500;
    color: ${gold};
    margin-left: 0.375rem;
`

export const DateRow = styled.div`
    text-align: center;
    font-size: 0.875rem;
    color: #6b7280;
    margin-bottom: 1rem;
`

export const InvolvementRow = styled.div<{ $type: 'lent' | 'borrowed' | 'none' }>`
    text-align: center;
    font-size: 0.9375rem;
    font-weight: 600;
    color: ${({ $type }) => {
        if ($type === 'lent') return '#047857'
        if ($type === 'borrowed') return '#b91c1c'
        return '#6b7280'
    }};
    margin-bottom: 1.5rem;
`

export const SectionTitle = styled.div`
    font-size: 0.75rem;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 0.5rem;
`

export const SplitTypeBadge = styled.span`
    display: inline-block;
    padding: 0.125rem 0.5rem;
    border-radius: 999px;
    background: #fef3e2;
    color: ${gold};
    font-size: 0.6875rem;
    font-weight: 600;
    margin-left: 0.375rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
`

export const SplitSection = styled.div`
    margin-bottom: 1.5rem;
`

export const SplitList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`

export const SplitRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.625rem;
    padding: 0.5rem 0.75rem;
    border: 1px solid #f0e0d6;
    border-radius: 8px;
    background: white;
`

export const SplitName = styled.span`
    flex: 1;
    font-size: 0.875rem;
    color: #262626;
`

export const SplitAmount = styled.span`
    font-size: 0.875rem;
    font-weight: 600;
    color: ${darkOrange};
`

export const ThumbnailGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
    gap: 0.5rem;
    margin-bottom: 1.5rem;
`

export const Thumbnail = styled.div`
    aspect-ratio: 1;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #e5e7eb;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &:hover {
        border-color: ${orange};
    }
`

export const AuditInfo = styled.div`
    font-size: 0.75rem;
    color: #6b7280;
    border-top: 1px solid #f0e0d6;
    padding-top: 0.75rem;
    line-height: 1.5;
`

export const AuditLine = styled.div`
    margin-bottom: 0.25rem;

    &:last-child {
        margin-bottom: 0;
    }
`

export const FooterActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    width: 100%;
`

export const ActionButton = styled.button<{ $variant: 'primary' | 'secondary' | 'danger' }>`
    padding: 0.5rem 1rem;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.15s ease;
    border: 1px solid transparent;

    background: ${({ $variant }) => {
        if ($variant === 'primary') return darkOrange
        if ($variant === 'danger') return '#dc2626'
        return 'white'
    }};
    color: ${({ $variant }) => {
        if ($variant === 'primary' || $variant === 'danger') return 'white'
        return '#374151'
    }};
    border-color: ${({ $variant }) => {
        if ($variant === 'primary') return darkOrange
        if ($variant === 'danger') return '#dc2626'
        return '#d1d5db'
    }};

    &:hover {
        opacity: 0.9;
    }
`

export const ImageOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    cursor: pointer;

    img {
        max-width: 90%;
        max-height: 90%;
        object-fit: contain;
    }
`
